export const STATS = [
  { end: 30, suffix: ' sec', label: 'Setup time', icon: 'clock' },
  { end: 99.9, suffix: '%', label: 'Uptime SLA', icon: 'shield', isDecimal: true },
  { end: 3, suffix: 'x', label: 'Faster than email reviews', icon: 'pin' },
  { end: 70, suffix: '%', label: 'Cheaper than Markup.io', icon: 'users' },
];
